module.exports = __webpack_public_path__ + "static/media/btn-bg-purple.f74d5a78.png";